// Địa chỉ đầy đủ của API cho chỗ KHÔNG đi qua axios (vd action của antd Upload).
// Bỏ dấu "/" thừa ở cuối VITE_API_URL để không ra "//v1/..." (backend trả 404).
export const apiUrl = (path: string) => `${(import.meta.env.VITE_API_URL || "").replace(/\/+$/, "")}/${path.replace(/^\/+/, "")}`;
